import { render, staticRenderFns } from "./Caizhi.vue?vue&type=template&id=5cd37695&scoped=true&"
import script from "./Caizhi.vue?vue&type=script&lang=js&"
export * from "./Caizhi.vue?vue&type=script&lang=js&"
import style0 from "./Caizhi.vue?vue&type=style&index=0&id=5cd37695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd37695",
  null
  
)

export default component.exports